import React, { useEffect } from 'react';

const LoginSuccess = () => {
  const queryParameters = new URLSearchParams(window.location.search)
  const auth_code = queryParameters.get("auth_code");
  const request_id = queryParameters.get("request_id");

  localStorage.setItem("auth_code", auth_code);
  localStorage.setItem("request_id", request_id);
  
  useEffect(() => {
    const auth_code = localStorage.getItem("auth_code");
    const request_id = localStorage.getItem("request_id");

    if (auth_code && request_id) {
      const timer = setTimeout(() => {
        window.close();
      }, 2000);
  
      return () => clearTimeout(timer);
    }
  }, [])

  return (
    <div>
      Login Succes
    </div>
  );
}

export default LoginSuccess;